import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import PaginateModel from "@/model/paginate";
import Quote from "@/model/quote";
import quoteApi from "@/api/quoteApi";

@Module({ namespaced: true })
export default class QuoteModule extends VuexModule {
  quotes: Quote[] = [];
  paginate: PaginateModel;
  @Mutation
  setQuotes(quotes: Quote[]): void {
    this.quotes = quotes;
  }
  @Mutation
  setPaginate(paginate: PaginateModel): void {
    this.paginate = paginate;
  }
  @Action({ rawError: true })
  async fetchList(query: any): Promise<void> {
    const { list, paginate } = await quoteApi.getAll(query);
    this.context.commit("setQuotes", list);
    this.context.commit("setPaginate", paginate);
  }

  @Action({ rawError: true })
  async fetchListByCustomer(query: any): Promise<void> {
    const { list, paginate } = await quoteApi.getAllByCustomer(query);
    this.context.commit("setQuotes", list);
    this.context.commit("setPaginate", paginate);
  }

  get getQuotes(): Quote[] {
    return this.quotes;
  }
  get getPaginate(): PaginateModel {
    return this.paginate;
  }
}
